// extracted by mini-css-extract-plugin
export default {"main-button":"Button_main-button__vqidP","primary-button":"Button_primary-button__cukSu","secondary-button":"Button_secondary-button__cyWE7"};